import { render, staticRenderFns } from "./OrganizationTalent.vue?vue&type=template&id=1e7e872d&scoped=true"
import script from "./OrganizationTalent.vue?vue&type=script&lang=js"
export * from "./OrganizationTalent.vue?vue&type=script&lang=js"
import style0 from "./OrganizationTalent.vue?vue&type=style&index=0&id=1e7e872d&prod&lang=scss&scoped=true"
import style1 from "./OrganizationTalent.vue?vue&type=style&index=1&id=1e7e872d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7e872d",
  null
  
)

export default component.exports